import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from '@components/showAlert/useAlertHook';
import { apiErrorMessage } from '@functions/api-error-message';
import { AutomationService, StageAutomation } from '../services/automation.service';

/// As regras de coluna de um quadro: carregar, ligar e desligar, excluir.
export const useStageRules = (boardId?: string) => {
    const { t } = useTranslation();
    const { showAlert, alertDelete } = useAlert();
    const [rules, setRules] = useState<StageAutomation[] | null>(null);

    const load = useCallback(() => {
        if (!boardId) return;

        new AutomationService()
            .stages(boardId)
            .then((res) => setRules(res.data.data ?? []))
            .catch(() => setRules([]));
    }, [boardId]);

    useEffect(() => {
        setRules(null);
        load();
    }, [load]);

    const toggle = async (rule: StageAutomation) => {
        // Otimista: o switch responde no clique; se o servidor recusar, a lista volta ao dele.
        setRules((current) =>
            (current ?? []).map((item) =>
                item.id === rule.id ? { ...item, enabled: !item.enabled } : item));

        try {
            const { id, boardColumnName, sortOrder, ...body } = rule;
            await new AutomationService().updateStage(id, { ...body, enabled: !rule.enabled });
        } catch (err) {
            showAlert(apiErrorMessage(err), 'error', 4000);
            load();
        }
    };

    /// Excluir não tem desfazer (some condição, mensagem e atraso), por isso pergunta antes.
    const remove = (rule: StageAutomation, onRemoved: () => void) =>
        alertDelete(rule.id, async () => {
            try {
                await new AutomationService().deleteStage(rule.id);
                showAlert(t('automacoes.regraRemovida'), 'success', 2500);
                onRemoved();
                load();
            } catch (err) {
                showAlert(apiErrorMessage(err), 'error', 4000);
            }
        }, rule.name);

    return { rules, load, toggle, remove };
};
